module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/map-zh-hant-dc6899f9e791b10d0ed15355078dce2b.png";